import createIcon from '../../createIcon';

/**
 * @component @name GMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAxMVYxM0gxNC41VjE1SDkuNVY5SDE2LjVDMTYuNSA3LjkgMTUuNiA3IDE0LjUgN0g5LjVDOC40IDcgNy41IDcuOSA3LjUgOVYxNUM3LjUgMTYuMSA4LjQgMTcgOS41IDE3SDE0LjVDMTUuNiAxNyAxNi41IDE2LjEgMTYuNSAxNVYxMUgxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GMobiledata = createIcon('GMobiledata', [
  [
    'path',
    {
      d: 'M12.5 11V13H14.5V15H9.5V9H16.5C16.5 7.9 15.6 7 14.5 7H9.5C8.4 7 7.5 7.9 7.5 9V15C7.5 16.1 8.4 17 9.5 17H14.5C15.6 17 16.5 16.1 16.5 15V11H12.5Z',
      key: '2stef6',
    },
  ],
]);

export default GMobiledata;
